import * as cn from "classnames";
import * as React from "react";
import { FieldError } from "./ErrorMessage";
import { FieldInfo } from "rd-redux-forms";

import "./Fieldset.css";
import { SvgIcon } from "./SvgIcon";

export interface FieldsetProps {
    label?: string;
    errorMessage?: FieldInfo;

    children: React.ReactChild;
    icon?: string;
    isBadDateSvg?: boolean;
    isMandatory?: boolean;
    className?: string;
    svgClassName?: string;
    errorMessageClassName?: string;
    isDisabledErrorMsg?: boolean;
    showLastError?: boolean;
}

export function Fieldset({
    label,
    className,
    children,
    icon,
    errorMessage,
    isBadDateSvg,
    isMandatory,
    isDisabledErrorMsg,
    errorMessageClassName,
    showLastError,
    svgClassName
}: FieldsetProps) {
    return (
        <fieldset
            className={cn("Fieldset", className, { error: errorMessage && errorMessage.visualState === "invalid" })}
        >
            {label && (
                <legend className="Fieldset__label">
                    {isMandatory ? (
                        <span>{label}</span>
                    ) : (
                        <span>
                            {label}
                            <span style={{ color: "#bbb" }}> - optional</span>
                        </span>
                    )}
                </legend>
            )}
            <div className={cn("Fieldset__content")}>
                <div className="Fieldset__input">{children}</div>
                {icon && (
                    <div className={cn("Fieldset__icon", svgClassName)}>
                        <SvgIcon className={cn(isBadDateSvg ? "date-bad-svg" : "")} svg={icon} />
                    </div>
                )}
            </div>
            {/* {isMandatory && <span className="Fieldset__mandatory">Mandatory fields</span>} */}
            {errorMessage &&
                !isDisabledErrorMsg && (
                    <FieldError
                        className={cn(isMandatory ? "Fieldset__mandatory-error important" : "", errorMessageClassName)}
                        showLastError={showLastError}
                        field={errorMessage}
                    />
                )}
        </fieldset>
    );
}
